import React from 'react';
import PublicLayout from '../../components/public/PublicLayout';
import { GraduationCap, Video, FileText, BookOpen } from 'lucide-react';

const TrainingMaterialsPage = () => {
  const materials = [
    {
      icon: Video,
      title: 'Video Tutorials',
      description: 'Step-by-step video guides on respiratory therapy techniques and equipment operation.',
      count: '20+ Videos',
      status: 'Coming Soon'
    },
    {
      icon: FileText,
      title: 'Clinical Protocols',
      description: 'Downloadable protocols for common respiratory care procedures and interventions.',
      count: '15+ Protocols',
      status: 'Coming Soon'
    },
    {
      icon: BookOpen,
      title: 'Training Manuals',
      description: 'Comprehensive training manuals for respiratory therapists at all experience levels.',
      count: '5+ Manuals',
      status: 'Coming Soon'
    },
    {
      icon: GraduationCap,
      title: 'Certification Prep',
      description: 'Study materials and practice exams for respiratory therapy certification.',
      count: '10+ Resources',
      status: 'Coming Soon'
    }
  ];

  return (
    <PublicLayout>
      <div className="py-5">
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                   style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <GraduationCap className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Training Materials</h1>
              <p className="lead text-muted">
                Educational resources for respiratory care professionals
              </p>
            </div>
          </div>

          {/* Materials Grid */}
          <div className="row g-4 mb-5">
            {materials.map((material, index) => {
              const Icon = material.icon;
              return (
                <div key={index} className="col-md-6 col-lg-3">
                  <div className="card h-100 shadow-sm border-0 text-center">
                    <div className="card-body p-4">
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" 
                           style={{ width: '64px', height: '64px', backgroundColor: '#e8f5e9' }}>
                        <Icon style={{ color: '#6B8E23' }} size={32} />
                      </div>
                      <h5 className="fw-bold text-dark mb-2">{material.title}</h5>
                      <p className="text-muted small mb-3">{material.description}</p>
                      <div className="mb-2">
                        <span className="badge text-white" style={{ backgroundColor: '#6B8E23' }}>{material.count}</span>
                      </div>
                      <span className="badge bg-warning text-dark">{material.status}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Info Section */}
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-5">
                  <h3 className="h4 fw-bold text-dark mb-4">What You'll Find Here</h3>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <h5 className="fw-bold text-dark mb-3"><i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>For Students</h5>
                      <ul className="list-unstyled text-muted">
                        <li className="mb-2">• Foundational respiratory care concepts</li>
                        <li className="mb-2">• Equipment operation guides</li>
                        <li className="mb-2">• Clinical skills demonstrations</li>
                        <li>• Exam preparation materials</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h5 className="fw-bold text-dark mb-3"><i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>For Professionals</h5>
                      <ul className="list-unstyled text-muted">
                        <li className="mb-2">• Advanced clinical protocols</li>
                        <li className="mb-2">• Continuing education resources</li>
                        <li className="mb-2">• Latest research summaries</li>
                        <li>• Professional development tools</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="card shadow border-0" style={{ background: 'linear-gradient(135deg, #6B8E23 0%, #556B1F 100%)' }}>
                <div className="card-body p-5 text-center text-white">
                  <h3 className="h4 fw-bold mb-3">Training Materials in Development</h3>
                  <p className="mb-4">
                    Our team is currently developing comprehensive training materials. 
                    ARCA members will receive early access when these resources become available.
                  </p>
                  <a href="/get-involved/become-member" className="btn btn-light btn-lg fw-bold me-3">Become a Member</a>
                  <a href="/contact" className="btn btn-outline-light btn-lg">Contact Us</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default TrainingMaterialsPage;
